<template>
    <v-card class="mt-5 ml-5 p-5 card-dashboard">
        <v-card-text class="card-dashboard-body">
            <v-icon class="card-dashboard-icon mb-4">{{ icon }}</v-icon>
            <p class="display-1 text--primary mb-2">
                {{ count }}
            </p>
            <p class="mb-2">{{ text }}</p>
        </v-card-text>
        <div class="card-dashboard-footer">
            <v-card-actions>
                <v-btn
                    class="mt-0 w-100"
                    text
                    color=#03A9F4
                    :to="{name: getRoute(), query: getFilter()}"
                >
                    {{ button }}
                </v-btn>
            </v-card-actions>
        </div>
    </v-card>
</template>

<script>
export default {
    name: "CardDashboard",
    props: {
        text: String,
        button: String,
        type: String,
        count: Number,
        icon: String
    },
    methods: {
        getFilter() {
            if (this.type === "pendingInvoice") {
                return {pendingInvoice: "pending"}
            }
            if (this.type === "hotel") {
                return null
            }
            if (this.type === "status") {
                return {status: "pending"}
            }
            if (this.type === "thisMonth") {
                return {thisMonth: true}
            }
            if (this.type === "thisMonthHotel") {
                return {thisMonth: true}
            }
            if (this.type === "unanswered") {
                return {status: "unanswered"}
            }
            if (this.type === "unpaid") {
                return {status: "unpaid"}
            }
        },
        getRoute() {
            if (this.type === "hotel") {
                return 'hotelList'
            }
            if (this.type === "pendingInvoice") {
                return 'reserveList'
            }
            if (this.type === "status") {
                return 'reserveList'
            }
            if (this.type === "thisMonth") {
                return 'reserveList'
            }
            if (this.type === "thisMonthHotel") {
                return 'hotelList'
            }
            if (this.type === "unanswered") {
                return 'reserveList'
            }
            if (this.type === "unpaid") {
                return 'reserveList'
            }
        },
    }
}

</script>

<style lang="scss" scoped>
.card-dashboard {
    min-height: 220px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    box-shadow: none !important;
    .card-dashboard-body {
        display: flex;
        align-items: center;
        flex-direction: column;
        text-align: center;
        padding-bottom: 0;
    }
    .card-dashboard-icon {
        width: 35px;
        height: 35px;
        background: #BBDEFB;
        border-radius: 50%;
        padding: .5rem;
        color: #1E88E5;
    }
}
</style>
